import React from "react";
import { BookOpen, ShieldAlert, Award, Sparkles } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const About = () => {
  const { t } = useLanguage();

  const sections = [
    { icon: BookOpen, t_t: "about_s1_t", t_b: "about_s1_b" },
    { icon: Award, t_t: "about_s2_t", t_b: "about_s2_b" },
    { icon: Sparkles, t_t: "about_s3_t", t_b: "about_s3_b" },
    { icon: ShieldAlert, t_t: "about_s4_t", t_b: "about_s4_b" },
  ];

  return (
    <div data-testid="about-page" className="max-w-4xl mx-auto px-4 sm:px-8 py-12 sm:py-20">
      <div className="mb-12">
        <p className="text-xs uppercase tracking-[0.25em] text-gold mb-3">{t("method_label")}</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-forest font-bold tracking-tight mb-5">
          {t("about_title")}
        </h1>
        <p className="text-mute leading-relaxed text-lg">{t("about_intro")}</p>
      </div>

      <div className="space-y-6">
        {sections.map((s, idx) => (
          <div key={idx} data-testid={`about-section-${idx}`} className="clay-surface rounded-3xl p-8 flex gap-5">
            <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-forest/10 text-forest flex items-center justify-center">
              <s.icon className="w-6 h-6" />
            </div>
            <div>
              <h2 className="font-heading text-2xl text-forest font-semibold mb-2">{t(s.t_t)}</h2>
              <p className="text-mute leading-relaxed">{t(s.t_b)}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 rounded-3xl bg-forest text-sand p-10 relative overflow-hidden">
        <div className="absolute inset-0 bg-islamic-pattern opacity-10" />
        <div className="relative">
          <p className="arabic text-2xl text-gold mb-4 text-center">
            وَإِذَا مَرِضْتُ فَهُوَ يَشْفِينِ
          </p>
          <p className="text-center text-sand/90 italic">{t("about_verse_en")}</p>
        </div>
      </div>
    </div>
  );
};

export default About;
